import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function reviewRecords() {
    return request({
        url: V1_API_URL_PREFIX + "/performance-review",
        method: 'GET'
    });
}

const replacer = (key, value) =>
    value instanceof Object && !(value instanceof Array) ?
        Object.keys(value)
            .sort()
            .reduce((sorted, key) => {
                sorted[key] = value[key];
                return sorted
            }, {}) :
        value;

export function saveOrUpdateReview(record) {
    let items = [];
    Object.keys(record.performance).forEach(function(key) {
        items.push({id: record.performance[key].id , text: record.performance[key].text, value: record.performance[key].value, comments: record.performance[key].comments});
    });
    record.performance = items;
    return request({
        url: V1_API_URL_PREFIX + "/performance-review/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteReview(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/performance-review/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function revision() {
    return request({
        url: V1_API_URL_PREFIX + "/performance-reviews/latestRevision",
        method: 'GET'
    });
}

export function addRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/performance-review/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}